import React from "react";
import "./styles.scss";

function Input(props) {
  const { label, type, lablePosition = "left" } = props;
  const adaptiveStyle =
    lablePosition === "top"
      ? { wrapper: "", label: "" }
      : { wrapper: "d-flex flex-row align-items-center", label: "mb-0" };
  return (
    <div
      className={`uploading-flow-input-wrapper ${adaptiveStyle.wrapper} text-dark mb-5`}
    >
      <label className={adaptiveStyle.label}> {label}: </label>
      {type === "textarea" ? (
        <textarea className="form-control" rows="5" {...props} />
      ) : (
        <input className="form-control p-0" {...props} />
      )}
    </div>
  );
}
export default Input;
